import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { PaymentPage } from "@/pages/payment/index";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const SearchSchema = z.object({
	tab: z.enum(["sent", "received"]).optional(),
});

export type PaymentSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute("/_market/payment/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => (
		<DashboardLayout>
			<PaymentPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
